import axios from "axios";
import { Urls } from "../urls";
import { ServiceUrls } from "../serviceUrls";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const deviceType = typeof navigator !== `undefined` && 
  navigator?.userAgent?.toLowerCase()?.includes("mobile") ? "mobile" : "web";

export const fetchTokenRepo = (data) => {
  let deviceTypeData = cookies.get('device-platform') || deviceType;
  return axios({
    method: "POST",
    baseURL: ServiceUrls.CUS_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    url: Urls.LOGIN_API,
    data: data,
    headers: { 'device-type': deviceTypeData },
  });
};

export const fetchTokenByRefreshRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.LOGIN_REFRESH_API,
    data: data,
  });
};

export const fetchUserRepo = (sessionKey) => {
  let deviceTypeData = cookies.get('device-platform') || deviceType;
  return axios({
    method: "GET",
    baseURL: ServiceUrls.CUS_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    url: Urls.USER_DETAIL_API,
    headers: { "sid": sessionKey, 'device-type': deviceTypeData },
  });
};

export const fetchAuthUserPermissionRepo = (sessionKey) => {
  return axios({
    method: "GET",
    url: Urls.USER_AUTH_PERMISSION_API,
  });
};

export const logoutUserRepo = (data) => {
  let deviceTypeData = cookies.get('device-platform') || deviceType;
  return axios({
    method: "POST",
    baseURL: ServiceUrls.CUS_SERVICE +
    axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    url: Urls.LOGOUT_API,
    data: data,
    headers: {'device-type': deviceTypeData, 'is-cms':1 },
  });
};

export const postUserActivityRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.USER_ACTIVITY,
    data: data,
  });
};

export const getUserActivityRepo = () => {
  return axios({
    method: "GET",
    url: Urls.USER_ACTIVITY,
  });
};

export const putUserDetailRepo = (id, data) => {
  return axios({
    method: "PUT",
    url: Urls.GET_USER_API + id + "/",
    data: data,
  });
};

export const getIdpPermissionsRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_IDP_PERMISSION_CHECK_API,
    params: params,
  });
};

export const getUserKeywordsRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_USER_KEYWORDS,
    params: params,
  });
};

export const postUserKeywordsRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.POST_USER_KEYWORDS,
    data: data,
  });
};

export const getUserFeedBackRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_USER_FEEDBACK,
    params: params,
  });
};

export const postUserFeedBackRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.POST_USER_FEEDBACK,
    data: data,
  });
};
export const commonSignInCheckRepo = (data) => {
  return axios({
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    url: window?.origin + "/dj-api/common-signin/validate",
    data: data,
  });
};
export const postValidateFieldsRepo = (data) => {
  return axios({
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    url: window?.origin + "/ajax/no-cache/user/validate-fields",
    data: data,
  });
};